"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ButtonView_type_1 = require("./types/ButtonView.type");
const common_1 = require("../common");
const buttonReset_styles_1 = require("../DesignSystem/styles/buttonReset.styles");
const focusRing_styles_1 = require("../DesignSystem/styles/focusRing.styles");
const Global_1 = require("../DesignSystem/tokens/Global");
const Icon_1 = require("../Icon");
const Button_1 = require("./desingTokens/Button");
const buttonUIStyles = {
    primary: {
        static: {
            backgroundColor: Button_1.buttonTokens.buttonPrimaryBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonPrimaryBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonPrimaryTextColor.getVar()
        },
        hover: {
            backgroundColor: Button_1.buttonTokens.buttonPrimaryHoverBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonPrimaryHoverBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonPrimaryHoverTextColor.getVar()
        },
        active: {
            backgroundColor: Button_1.buttonTokens.buttonPrimaryActiveBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonPrimaryActiveBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonPrimaryActiveTextColor.getVar()
        },
        focus: {
            backgroundColor: Button_1.buttonTokens.buttonPrimaryFocusBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonPrimaryFocusBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonPrimaryFocusTextColor.getVar()
        },
        disabled: {
            backgroundColor: Button_1.buttonTokens.buttonPrimaryDisabledBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonPrimaryDisabledBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonPrimaryDisabledTextColor.getVar()
        }
    },
    secondary: {
        static: {
            backgroundColor: Button_1.buttonTokens.buttonSecondaryBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonSecondaryBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonSecondaryTextColor.getVar()
        },
        hover: {
            backgroundColor: Button_1.buttonTokens.buttonSecondaryHoverBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonSecondaryHoverBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonSecondaryHoverTextColor.getVar()
        },
        active: {
            backgroundColor: Button_1.buttonTokens.buttonSecondaryActiveBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonSecondaryActiveBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonSecondaryActiveTextColor.getVar()
        },
        focus: {
            backgroundColor: Button_1.buttonTokens.buttonSecondaryFocusBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonSecondaryFocusBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonSecondaryFocusTextColor.getVar()
        },
        disabled: {
            backgroundColor: Button_1.buttonTokens.buttonSecondaryDisabledBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonSecondaryDisabledBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonSecondaryDisabledTextColor.getVar()
        }
    },
    alternate: {
        static: {
            backgroundColor: Button_1.buttonTokens.buttonAlternateBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonAlternateBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonAlternateTextColor.getVar()
        },
        hover: {
            backgroundColor: Button_1.buttonTokens.buttonAlternateHoverBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonAlternateHoverBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonAlternateHoverTextColor.getVar()
        },
        active: {
            backgroundColor: Button_1.buttonTokens.buttonAlternateActiveBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonAlternateActiveBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonAlternateActiveTextColor.getVar()
        },
        focus: {
            backgroundColor: Button_1.buttonTokens.buttonAlternateFocusBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonAlternateFocusBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonAlternateFocusTextColor.getVar()
        },
        disabled: {
            backgroundColor: Button_1.buttonTokens.buttonAlternateDisabledBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonAlternateDisabledBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonAlternateDisabledTextColor.getVar()
        }
    },
    text: {
        static: {
            backgroundColor: Button_1.buttonTokens.buttonTextBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonTextBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonTextTextColor.getVar()
        },
        hover: {
            backgroundColor: Button_1.buttonTokens.buttonTextHoverBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonTextHoverBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonTextHoverTextColor.getVar()
        },
        active: {
            backgroundColor: Button_1.buttonTokens.buttonTextActiveBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonTextActiveBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonTextActiveTextColor.getVar()
        },
        focus: {
            backgroundColor: Button_1.buttonTokens.buttonTextFocusBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonTextFocusBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonTextFocusTextColor.getVar()
        },
        disabled: {
            backgroundColor: Button_1.buttonTokens.buttonTextDisabledBackgroundColor.getVar(),
            borderColor: Button_1.buttonTokens.buttonTextDisabledBorderColor.getVar(),
            textColor: Button_1.buttonTokens.buttonTextDisabledTextColor.getVar()
        }
    }
};
const buttonHeightStyles = {
    s: {
        height: Button_1.buttonTokens.buttonHeightS.getVar(),
        width: Button_1.buttonTokens.buttonHeightS.getVar(),
        borderRadius: Button_1.buttonTokens.buttonHeightSBorderRadius.getVar(),
        paddingHorizontal: Button_1.buttonTokens.buttonHeightSPaddingHorizontal.getVar(),
        iconMargin: Button_1.buttonTokens.buttonHeightSIconMargin.getVar(),
        minWidth: Button_1.buttonTokens.buttonHeightSMinWidth.getVar(),
        fontSize: Button_1.buttonTokens.buttonHeightSFontSize.getVar(),
        fontWeight: Button_1.buttonTokens.buttonHeightSFontWeight.getVar(),
        lineHeight: Button_1.buttonTokens.buttonHeightSLineHeight.getVar()
    },
    m: {
        height: Button_1.buttonTokens.buttonHeightM.getVar(),
        width: Button_1.buttonTokens.buttonHeightM.getVar(),
        borderRadius: Button_1.buttonTokens.buttonHeightMBorderRadius.getVar(),
        paddingHorizontal: Button_1.buttonTokens.buttonHeightMPaddingHorizontal.getVar(),
        iconMargin: Button_1.buttonTokens.buttonHeightMIconMargin.getVar(),
        minWidth: Button_1.buttonTokens.buttonHeightMMinWidth.getVar(),
        fontSize: Button_1.buttonTokens.buttonHeightMFontSize.getVar(),
        fontWeight: Button_1.buttonTokens.buttonHeightMFontWeight.getVar(),
        lineHeight: Button_1.buttonTokens.buttonHeightMLineHeight.getVar()
    },
    l: {
        height: Button_1.buttonTokens.buttonHeightL.getVar(),
        width: Button_1.buttonTokens.buttonHeightL.getVar(),
        borderRadius: Button_1.buttonTokens.buttonHeightLBorderRadius.getVar(),
        paddingHorizontal: Button_1.buttonTokens.buttonHeightLPaddingHorizontal.getVar(),
        iconMargin: Button_1.buttonTokens.buttonHeightLIconMargin.getVar(),
        minWidth: Button_1.buttonTokens.buttonHeightLMinWidth.getVar(),
        fontSize: Button_1.buttonTokens.buttonHeightLFontSize.getVar(),
        fontWeight: Button_1.buttonTokens.buttonHeightLFontWeight.getVar(),
        lineHeight: Button_1.buttonTokens.buttonHeightLLineHeight.getVar()
    }
};
const setButtonUIStyles = (tokens, isDisabled) => isDisabled
    ? (0, styled_components_1.css) `
              background-color: ${tokens.disabled.backgroundColor};
              color: ${tokens.disabled.textColor};
              border-color: ${tokens.disabled.borderColor};
          `
    : (0, styled_components_1.css) `
              background-color: ${tokens.static.backgroundColor};
              color: ${tokens.static.textColor};
              border-color: ${tokens.static.borderColor};

              &:focus {
                  background-color: ${tokens.focus.backgroundColor};
                  color: ${tokens.focus.textColor};
                  border-color: ${tokens.focus.borderColor};
              }

              &:hover {
                  background-color: ${tokens.hover.backgroundColor};
                  color: ${tokens.hover.textColor};
                  border-color: ${tokens.hover.borderColor};
              }

              &:active {
                  background-color: ${tokens.active.backgroundColor};
                  color: ${tokens.active.textColor};
                  border-color: ${tokens.active.borderColor};
              }
          `;
const setButtonHeightStyles = (tokens, iconOnly) => (0, styled_components_1.css) `
    height: ${tokens.height};
    border-radius: ${tokens.borderRadius};
    padding-right: ${tokens.paddingHorizontal};
    padding-left: ${tokens.paddingHorizontal};
    font-size: ${tokens.fontSize};
    font-weight: ${tokens.fontWeight};
    line-height: ${tokens.lineHeight};

    ${iconOnly &&
    (0, styled_components_1.css) `
        width: ${tokens.width};
    `}

    ${!iconOnly &&
    (0, styled_components_1.css) `
        min-width: ${tokens.minWidth};

        > ${Icon_1.Icon.selector} {
            margin-right: ${tokens.iconMargin};
        }
    `}
`;
exports.StyledButton = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: ${Button_1.buttonTokens.buttonBorderWidth.getVar()} solid;
    box-sizing: border-box;
    white-space: nowrap;
    cursor: pointer;
    font-family: ${Global_1.globalTokens.fontFamily.getVar()};
    ${focusRing_styles_1.focusRing};

    ${({ controlHeight, iconOnly }) => {
    switch (controlHeight) {
        case common_1.CONTROL_HEIGHT.s:
            return setButtonHeightStyles(buttonHeightStyles.s, iconOnly);
        case common_1.CONTROL_HEIGHT.l:
            return setButtonHeightStyles(buttonHeightStyles.l, iconOnly);
        default:
            return setButtonHeightStyles(buttonHeightStyles.m, iconOnly);
    }
}}

    ${({ ui, isDisabled }) => {
    switch (ui) {
        case ButtonView_type_1.BUTTON_VIEW.secondary:
            return setButtonUIStyles(buttonUIStyles.secondary, isDisabled);
        case ButtonView_type_1.BUTTON_VIEW.alternate:
            return setButtonUIStyles(buttonUIStyles.alternate, isDisabled);
        case ButtonView_type_1.BUTTON_VIEW.text:
            return setButtonUIStyles(buttonUIStyles.text, isDisabled);
        default:
            return setButtonUIStyles(buttonUIStyles.primary, isDisabled);
    }
}}

    ${({ ui, isDisabled, controlHeight = common_1.CONTROL_HEIGHT.m }) => ui === ButtonView_type_1.BUTTON_VIEW.text &&
    (0, styled_components_1.css) `
            ${controlHeight === common_1.CONTROL_HEIGHT.s &&
        (0, styled_components_1.css) `
                padding-right: ${Button_1.buttonTokens.buttonTextHeightSPaddingHorizontal.getVar()};
                padding-left: ${Button_1.buttonTokens.buttonTextHeightSPaddingHorizontal.getVar()};
            `}

            ${controlHeight === common_1.CONTROL_HEIGHT.m &&
        (0, styled_components_1.css) `
                padding-right: ${Button_1.buttonTokens.buttonTextHeightMPaddingHorizontal.getVar()};
                padding-left: ${Button_1.buttonTokens.buttonTextHeightMPaddingHorizontal.getVar()};
            `}

            ${controlHeight === common_1.CONTROL_HEIGHT.l &&
        (0, styled_components_1.css) `
                padding-right: ${Button_1.buttonTokens.buttonTextHeightLPaddingHorizontal.getVar()};
                padding-left: ${Button_1.buttonTokens.buttonTextHeightLPaddingHorizontal.getVar()};
            `}
            
            border-width: ${Button_1.buttonTokens.buttonTextBorderWidth.getVar()};

            ${!isDisabled &&
        (0, styled_components_1.css) `
                &:hover,
                &:focus,
                &:active {
                    text-decoration: ${Button_1.buttonTokens.buttonTextDecoration.getVar()};
                }
            `}
        `}
    }

    ${({ isDisabled }) => isDisabled &&
    (0, styled_components_1.css) `
            cursor: default;

            & ${Icon_1.Icon.selector} {
                opacity: ${Button_1.buttonTokens.buttonDisabledIconOpacity.getVar()};
                filter: ${Button_1.buttonTokens.buttonDisabledIconFilter.getVar()};
            }
        `}
`;
//# sourceMappingURL=Button.styles.js.map